// eslint-disable-next-line
// @ts-nocheck
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { BookingListHead, BookingListToolbar } from '../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { getParkingSpaces, getParkingTotalRecords, setParkings } from '../store/state/parkingSlice';
import { useGetAllParkingSpaceLocationMutation } from '../store/api/parkingsApi';
import Loading from '../components/Loading';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// mock
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Model Name', alignRight: false },
  { id: 'regi. no', label: 'Reg. No', alignRight: false },
  { id: 'capacity', label: 'Seating Capacity', alignRight: false },
  { id: 'address', label: 'Address', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export default function MyParkingSpace() {
  const parkingSpacesData = useAppSelector(getParkingSpaces);
  const [parkingSpaces, setParkingSpaces] = useState([]);
  const [getAllParkingSpaceLocation, response] = useGetAllParkingSpaceLocationMutation();
  const token = JSON.parse(localStorage.getItem('login')) || null;
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const parkingTotalRecords = useAppSelector(getParkingTotalRecords);
  const filteredUsers = parkingSpaces;
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - parkingSpaces.length) : 0;
  const isUserNotFound = filteredUsers.length === 0;

  useEffect(() => {
    if (parkingSpacesData) {
      setParkingSpaces(parkingSpacesData);
    }
  }, [parkingSpacesData]);

  // Fetch parkings.
  useEffect(() => {
    if (token) {
      getAllParkingSpaceLocation({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          serviceProviderId: token.serviceProviderId,
          currentStage: 'pending',
        },
      });
    }
  }, []);

  // set data to store
  useEffect(() => {
    if (response.isSuccess) {
      dispatch(setParkings(response.data));
    }
  }, [response.isSuccess]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = parkingSpaces.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    await getAllParkingSpaceLocation({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: newPage,
        currentStage: 'pending',
        serviceProviderId: token.serviceProviderId,
      },
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getAllParkingSpaceLocation({
      token: token.token,
      payload: {
        offset: parseInt(event.target.value, 10),
        page: 0,
        currentStage: 'pending',
        serviceProviderId: token.serviceProviderId,
      },
    });
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    dispatch(
      getAllParkingSpaceLocation({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          name: event.target.value,
          currentStage: 'pending',
        },
      })
    );
  };

  return (
    <Page title="Vehicle Status">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Vehicle Status
          </Typography>
          <Button
            variant="contained"
            style={{ color: 'white', backgroundColor: '#E23744' }}
            onClick={() => {
              navigate('/dashboard/vehicle-overview', { replace: true });
            }}
            sx={{ marginBottom: '10px' }}
            size="medium"
          >
            <ArrowBackIcon />
          </Button>
        </Stack>
        <Card>
          <BookingListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            placeholder={'Search By Name'}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <BookingListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={parkingSpaces.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row) => {
                      const { id, name, role, capacity, currentStatus, company, avatarUrl, isVerified, vehicleDetailObj, address } = row;
                      const isItemSelected = selected.indexOf(name) !== -1;
                      return (
                        <TableRow
                          hover
                          key={id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}
                             onClick={() => {
                                navigate('/dashboard/addvehicle', {
                                  state: { id: id, editMode: true, isAdmin: false },
                                });
                              }} 
                              style={{cursor: 'pointer', color: 'blue'}}>
                              <Typography variant="subtitle2" noWrap pl={2}>
                                {vehicleDetailObj?.model}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell>
                            <Typography alignItems="left">{vehicleDetailObj?.registrationNumber}</Typography>
                          </TableCell>
                          <TableCell>
                            <Typography alignItems="left">{vehicleDetailObj?.seatingCapacity}</Typography>
                          </TableCell>
                          <TableCell>
                            <Typography alignItems="left">{address}</Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Label variant="ghost" color={(currentStatus === 'pending' && 'error') || 'success'}>
                              {sentenceCase(currentStatus === 'pending' ? 'Pending' : 'Approved')}
                            </Label>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={parkingTotalRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      {response.isLoading && <Loading />}
    </Page>
  );
}
